import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function InitiateCoordination() {
  return <section data-section-id="246496" id="strategic-legal-counsel" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_boardroom_prestige.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_boardroom_prestige.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662932/img/legal_boardroom_prestige.png-wvc-sizes" alt="Professional legal boardroom" className="absolute inset-0 w-full h-full object-cover opacity-20 mix-blend-multiply pointer-events-none" loading="lazy" decoding="async" />

      {}
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] bg-primary/10 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] bg-secondary/20 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold tracking-tight mb-12 text-foreground">Ready to secure your legal counsel?</h2>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <Button size="lg" className="w-full sm:w-auto text-lg h-16 px-10 shadow-lg shadow-primary/30 bg-primary text-primary-foreground hover:opacity-90 rounded-sm" asChild>
              <Link to="#consultation-form">
                Request Consultation
                <ArrowRight className="ml-2 size-6" />
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" className="w-full sm:w-auto text-lg h-16 px-10 border-primary/40 hover:bg-primary/5 text-foreground rounded-sm" asChild>
              <Link to="/OurPeoplePage">
                Meet our team
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}